module.exports = __webpack_public_path__ + "dd5099f0f99568d4b1f1460ee154aca6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/angry-3.png
// module id = 1985
// module chunks = 0